import type { ReceiptReportColumn, ReceiptReportRow, ReceiptReportType } from '@/types/reporte';

export function uruguayMonthRange(now = new Date()) {
  const parts = new Intl.DateTimeFormat('en-US', { timeZone: 'America/Montevideo', year: 'numeric', month: '2-digit' }).formatToParts(now);
  const year = Number(parts.find(p => p.type === 'year')!.value);
  const month = Number(parts.find(p => p.type === 'month')!.value);
  const lastDay = new Date(Date.UTC(year, month, 0)).getUTCDate();
  const prefix = `${year}-${String(month).padStart(2, '0')}`;
  return { start: `${prefix}-01`, end: `${prefix}-${lastDay}` };
}

// Display columns are a whitelist: API metadata and row internals are never table columns.
const commonColumns: ReceiptReportColumn[] = [
  { key: 'numero_recibo', label: 'Recibo', numeric: false },
  { key: 'numero_contrato', label: 'Contrato', numeric: false },
];
const ownerColumns: ReceiptReportColumn[] = [
  { ...commonColumns[0], label: 'Número' }, commonColumns[1],
  { key: 'propietario_nombre', label: 'Propietario', numeric: false },
  { key: 'alquiler', label: 'Alquiler', numeric: true, currencyPrefix: true },
  { key: 'comision', label: 'Comisión', numeric: true },
  { key: 'iva', label: 'IVA', numeric: true },
  { key: 'impuestos', label: 'Impuestos', numeric: true },
  { key: 'importe', label: 'Importe', numeric: true },
];
const tenantColumns: ReceiptReportColumn[] = [
  ...commonColumns,
  { key: 'inquilino_nombre', label: 'Inquilino', numeric: false },
  { key: 'propietario_monto', label: 'Propietario', numeric: true, currencyPrefix: true },
  { key: 'comision', label: 'Comisión', numeric: true },
  { key: 'interes', label: 'Interés', numeric: true },
  { key: 'iva', label: 'IVA', numeric: true },
  { key: 'alquiler', label: 'Alquiler', numeric: true },
];

export function receiptReportColumns(type: ReceiptReportType): readonly ReceiptReportColumn[] {
  return type === 'PROPIETARIO' ? ownerColumns : tenantColumns;
}

export const receiptReportAmount = (value: number) => value.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

export function receiptReportCell(row: ReceiptReportRow, column: ReceiptReportColumn): string {
  const value = row[column.key];
  const currency = row.currencies?.[column.key] ?? row.moneda;
  const prefix = column.currencyPrefix ? `${currency} ` : '';
  if (typeof value !== 'string' && typeof value !== 'number') return `${prefix}—`;
  if (!column.numeric) return String(value);
  if (value === '' || !Number.isFinite(Number(value))) return `${prefix}—`;
  const suffix = !column.currencyPrefix && currency !== row.moneda ? ` ${currency}` : '';
  return prefix + receiptReportAmount(Number(value)) + suffix;
}
